const radioInputs = document.querySelectorAll("input[name='flexRadioDefault']")
const ccInput = document.querySelector("#cc-visa")
const ccFormControls = document.querySelectorAll("#form-data-cc .form-control")

export const activateCCInput = () => {
    if (radioInputs.length) {
        for (const input of radioInputs) {
            input.addEventListener("change", () => {
                for (const control of ccFormControls) {
                    if (!ccInput.checked) {
                        control.disabled = true
                    } else {
                        control.disabled = false
                    }
                }
            })
        }
    }
}
